import { DataSourceType } from "components/Admin/Organizations/OrganizationDetail/OrganizationDataSources/types";
import BaseService from "./BaseService";

export default class DataSourcesService extends BaseService {
    protected urlBase: string = "api/Organizations";

    async getOrganizationDataSources(): Promise<DataSourceType[]> {
        const orgDataSources = await this.get(
            new URLSearchParams({}),
            "GetOrganizationDataSources",
        );

        return orgDataSources;
    }

    async setOrganizationDataSources(
        updatedDataSources: DataSourceType[],
    ): Promise<boolean> {
        const res = await this.post(
            JSON.stringify(updatedDataSources),
            new URLSearchParams({}),
            "SetOrganizationDataSources",
        );

        return res;
    }
}
